import { render, staticRenderFns } from "./PublicEvents.vue?vue&type=template&id=207c3bd5&scoped=true"
import script from "./PublicEvents.vue?vue&type=script&lang=js"
export * from "./PublicEvents.vue?vue&type=script&lang=js"
import style0 from "./PublicEvents.vue?vue&type=style&index=0&id=207c3bd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c3bd5",
  null
  
)

export default component.exports